/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component } from 'react'
import styles from './styles.scss'
import { connect } from 'react-redux'
import Elements from './Elements'
import panzoom from '@/lib/panzoom/index'

import {
  getZoom,
  getTranslation,
  getPages,
  getActualPage,
  getActualPageIndex
} from '@/store/getters'
import {
  setActivePage,
  setElements,
  setActiveElement,
  setZoom,
  setZoomableInstance
} from '@/store/actions'

/** Components */
import { getMagazine } from "../../../../store/getters";
import { pageSizeFromMagazine } from "../../../../utils/pageSize";

const { RulersGuides } = require('@/lib/rulers')
const { RulerEvents } = require('@/lib/event')
const { DragRuler } = require('@/lib/dragDrop')

class Pages extends Component {
  constructor(props) {
    super(props)

    this.state = {
      pageSize: pageSizeFromMagazine(props.magazine),
    }

    this.ruler = null
    this.zoomInstance = null
    this.stageContainer = React.createRef()
    this.contentContainer = React.createRef()
    this.rulerContainer = React.createRef()
    this.stage = React.createRef()
  }

  componentDidMount() {
    const event = new RulerEvents()
    const drag = new DragRuler(event)
    const { current } = this.stage

    this.zoomInstance = panzoom(current, {
      disableMouseDown: false,
      disableDoubleClick: true,
      disableTextInterptor: true,
      bounds: true,
      boundsPadding: 0,
      autocenter: true,
      beforeWheel: e => {
        if (e.ctrlKey) return !e.ctrlKey

        return !e.altKey
      },
      filterKey: e => {
        if (
          e.keyCode === 37 ||
          e.keyCode === 38 ||
          e.keyCode === 39 ||
          e.keyCode === 40
        )
          return true
        else if (e.keyCode === 107 || e.keyCode === 109) e.preventDefault()
      }
    })

    this.zoomInstance.on('zoom', e => {
      this.props.setZoom(e.getTransform())
    })

    this.zoomInstance.on('pan', e => {
      return false
    })

    this.ruler = new RulersGuides(
      drag,
      this.rulerContainer.current,
      this.rulerContainer.current,
      this.state.pageSize.width,
      this.state.pageSize.height,
      this.zoomInstance
    )

    setTimeout(() => {
      this.props.setZoomableInstance(this.zoomInstance)
      this.props.setZoom(this.zoomInstance.getTransform())
    }, 1000)
  }

  render() {
    const { pageSize } = this.state

    const {
      translation,
      actualPage,
      actualPageIndex,
      actualZoom
    } = this.props

    const formatZoom = Math.round(actualZoom.scale * 100)

    return (
      <div
        ref={this.stageContainer}
        className={`
          ${styles['wrapper-editor']} 
        `}
      >
        <div
          className={styles['wrapper-editor__ruler']}
          ref={this.rulerContainer}
        >
          <div ref={this.contentContainer} className={`${styles[`wrapper-editor__content${formatZoom > 100 ? '__active-overflow' : ''}`]} `} >
            <div className={styles['wrapper-editor__stage']} ref={this.stage}>
              <div
                className={styles['wrapper-editor__pages']}
                style={pageSize}
              >
                <div className={styles['wrapper-editor__page-info']}>
                  <span>
                    {!!actualPageIndex
                      ? `${translation('general-page')} ${actualPageIndex + 1}`
                      : translation('general-cover')
                    }

                  </span>
                </div>
                {actualPage && (
                  <div
                    ref={this.rootEl}
                    className={`${styles['wrapper-editor-page']} ${styles['wrapper-editor__page']}`}
                    id={`page${this.props.id}`}
                    style={actualPage.properties || { background: '#FFF' }}
                  >
                    <Elements />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  const magazine = getMagazine(state)
  const pages = getPages(state)
  const actualPage = getActualPage(state)
  const actualPageIndex = getActualPageIndex(state)
  const actualZoom = getZoom(state)
  return { translation, magazine, pages, actualPage, actualPageIndex, actualZoom }
}

export default connect(
  mapStateToProps,
  { setActivePage, setElements, setActiveElement, setZoom, setZoomableInstance }
)(Pages)


// WEBPACK FOOTER //
// ./src/pages/Editor/components/Pages/index.js